<template>
	<div>
		<el-dialog title="编辑账号" :visible.sync="formOpen" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :before-close="formClose">
			<div v-loading="$store.state.formload">
				<el-form :model="EAform" :rules="EArules" ref="EAform" :label-width="$store.state.width>$store.state.minwidth?'110px':''">
					<el-row>
						<el-col :md="24">
							<el-form-item label="账号" prop="username">
								<el-input v-model="EAform.username" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="24">
							<el-form-item label="密码" prop="password">
								<el-input v-model="EAform.password" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="24">
							<el-form-item label="手机号" prop="mobile">
								<el-input v-model="EAform.mobile" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="24">
							<el-form-item label="是否启用" prop="state">
								<el-select v-model="EAform.state" placeholder="请选择" style="width: 100%;">
									<el-option label="启用" value="1"></el-option>
									<el-option label="禁用" value="0"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="formOpen = false">取 消</el-button>
					<el-button type="primary" @click="save()">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<el-row>
			<el-col :md="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item>账号管理</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :md="8">
				<el-input v-model="find" placeholder="请输入内容" :size="$store.state.width<$store.state.minwidth?'small':'medium'">
					<el-button slot="append" icon="el-icon-search" @click="Find()">搜索</el-button>
				</el-input>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-table id="table" :data="$store.state.main.qaedasUlist.list" size="mini" stripe border class="table">
					<el-table-column type="index" width="40"></el-table-column>
					<el-table-column prop="projectInfo.name" label="项目名称"></el-table-column>
					<el-table-column prop="qaedasInfo.name" label="基地名称"></el-table-column>
					<el-table-column prop="username" label="账号"></el-table-column>
					<el-table-column prop="node_password" label="密码" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
					<el-table-column prop="mobile" label="手机号" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
					<el-table-column prop="state" label="状态" v-if="$store.state.width>$store.state.minwidth">
						<template slot-scope="scope">
							<span>{{ scope.row.state==1?'启用':'禁用' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row class="pagin">
			<el-col :span="24">
				<div>
					<el-pagination background :small="$store.state.width<$store.state.minwidth" align="center" @size-change="changeSize" @current-change="nextpage" :current-page="$store.state.production.page" :page-sizes="[20, 50, 100, 200]" :page-size="$store.state.production.pagesize" :layout="$store.state.width>$store.state.minwidth?'total, sizes, prev, pager, next, jumper':'prev, pager, next'" :total="$store.state.main.qaedasUlist.page.total"></el-pagination>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import FileSaver from 'file-saver';
	import XLSX from 'xlsx';
	export default {
		data() {
			return {
				formOpen: false,
				EAform: {
					id: '',
					username: '',
					password: '',
					mobile: '',
					state: ''
				},
				EArules: {
					username: [
						{ required: true, message: '请输入账号', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' },
						{ min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
					],
					mobile: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
						{ min: 11, max: 11, message: '长度在 11 个字符', trigger: 'blur' }
					],
					state: [
						{ required: true, message: '请选择是否启用', trigger: 'blur' }
					]
				},
				find: ''
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal){
					
				}
			}
		},
		mounted: function () {
			this.$store.commit('pagesize',20);
			this.$store.commit('page',1);
			this.load();
		},
		methods: {
			load()
			{
				this.$store.commit('mainload',true);
				this.getqaedaslist()
				.then(()=>{
					this.$store.commit('mainload',false);
				});
			},
			changeSize(val) {
				this.$store.commit('pagesize',val);
				this.$store.commit('page',1);
				this.load();
			},
			nextpage(val) {
				this.$store.commit('page',val);
				this.load();
			},
			openEdit(value)
			{
				this.formOpen=true;
				this.$nextTick(()=>{
					this.$refs['EAform'].resetFields();
					this.EAform.id=value.m_qaedas_id;
					this.EAform.username=value.username;
					this.EAform.password=value.node_password;
					this.EAform.mobile=value.mobile;
					this.EAform.state=value.state;
				});
			},
			save()
			{
				this.$refs['EAform'].validate((valid) => {
					if (valid) {
						const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
						if (!reg.test(this.EAform.mobile)) {
							this.$message({ message: '请输入正确的手机号', center: true })
							return;
						}
						this.$store.commit('formload',true);
						let value={
							id: this.EAform.id,
							username: this.EAform.username,
							password: this.EAform.password,
							mobile: this.EAform.mobile,
							state: this.EAform.state
						};
						this.updateUserInfo(value)
						.then((response)=>{
							if(response.data.code==1)
							{
								this.formOpen=false;
							}
							this.$store.commit('formload',false);
						});
					}
				});
			},
			Find()
			{
				let value={
					keyword: this.find
				};
				this.$store.commit('page',1);
				this.getqaedaslist(value);
			}
		}
	}
</script>

<style scoped>
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.output{
		text-align: right;
	}
	.table{
		margin-top: 10px;
		width: 100%;
	}
	.add{
		margin-top: 1px;
		margin-left: 5px;
	}
	.pagin{
		margin-top: 10px;
	}
	.fm-img{
		width: 100px;
		height: 100px;
		border: 1px solid #d9d9d9;
		border-radius: 6px;
	}
		.slot_table{
		border: 1px solid #EBEEF5;
		border-collapse: collapse ;
	}
	.slot_table>.el-form-item {
		margin-bottom: 0px;
		color: #1991FA;
	}
</style>

<style>
	.el-message-box {
		width: 350px !important;
	}
</style>